import { gql } from 'graphql-request';

import {
  ProductsSetID,
  ProductsSetSelectedProductsID,
  ProductsSetSelectedProductsProductBlocked,
  ProductsSetSelectedProductsProductBrandLocalizedName,
  ProductsSetSelectedProductsProductBrandName,
  ProductsSetSelectedProductsProductBrandUUID,
  ProductsSetSelectedProductsProductFavorite,
  ProductsSetSelectedProductsProductID,
  ProductsSetSelectedProductsProductImageFile,
  ProductsSetSelectedProductsProductImageUUID,
  ProductsSetSelectedProductsProductName,
  ProductsSetSelectedProductsProductNanoID,
  ProductsSetSelectedProductsProductNda,
  ProductsSetSelectedProductsProductPreviewModelFile,
  ProductsSetSelectedProductsProductPreviewModelName,
  ProductsSetSelectedProductsProductUUID,
  ProductsSetSelectedProductsUUID,
  ProductsSetUUID
} from '../productsSetsTypes';

export interface FetchProductsSetByUserIdQueryResponse {
  id: ProductsSetID;
  uuid: ProductsSetUUID;
  selectedProducts: {
    id: ProductsSetSelectedProductsID;
    uuid: ProductsSetSelectedProductsUUID;
    product: {
      id: ProductsSetSelectedProductsProductID;
      uuid: ProductsSetSelectedProductsProductUUID;
      nanoId: ProductsSetSelectedProductsProductNanoID;
      name: ProductsSetSelectedProductsProductName;
      nda: ProductsSetSelectedProductsProductNda;
      blocked: ProductsSetSelectedProductsProductBlocked;
      favorite: ProductsSetSelectedProductsProductFavorite;
      image: {
        uuid: ProductsSetSelectedProductsProductImageUUID;
        file: ProductsSetSelectedProductsProductImageFile;
      };
      previewModel: {
        file: ProductsSetSelectedProductsProductPreviewModelFile;
        name: ProductsSetSelectedProductsProductPreviewModelName;
      } | null;
      brand: {
        uuid: ProductsSetSelectedProductsProductBrandUUID;
        name: ProductsSetSelectedProductsProductBrandName;
        localizedName: ProductsSetSelectedProductsProductBrandLocalizedName;
      };
    };
  }[];
}

export const FETCH_PRODUCTS_SET_BY_USER_ID_QUERY = gql`
  query ProductsSetByUserId($userId: ID!, $scope: ID) {
    productsSetByUserId(userId: $userId, scope: $scope) {
      id
      uuid
      selectedProducts {
        id
        uuid
        product {
          id
          uuid
          nanoId
          name
          nda
          blocked
          favorite
          image {
            uuid
            file
          }
          previewModel {
            file
            name
          }
          brand {
            uuid
            name
            localizedName
          }
        }
      }
    }
  }
`;
